<template>
  <div class="empty-module">
    <div class="head">
      <i class="iconfont el-button--text" :class="'icon--' + item.name"></i>{{item.name_cn}}
      <p class="operation pull-right">
        <el-dropdown @command="handleCommand" :trigger="isMobile ? 'click' : 'hover'">
          <span class="el-dropdown-link el-button--text">
            <i class="iconfont icon--menu-dot"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="hideModule">隐藏模块</el-dropdown-item>
            <el-dropdown-item command="sortModule" disabled>模块排序</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </p>
    </div>
    <div class="detail">
      <p>您未在该模块上传成果，将不会在主页显示</p>
      <el-button type="primary" plain @click="linkTo(item.name)">+ 添加新成果</el-button>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    item: Object,
    index: Number,
    isMobile: Boolean
  },
  data () {
    return {
      visible: false
    }
  },
  methods: {
    handleCommand (command) {
      if (command === 'sortModule') {
        this.$emit('sortModules')
      } else if (command === 'hideModule') {
        this.$emit('hideModule', this.index)
      }
    },
    linkTo (type) {
      this.$emit('linkTo', type)
    }
  }
}
</script>
<style lang="scss">
  @import './index.scss';
</style>



// WEBPACK FOOTER //
// src/pages/Index/EmptyModule/index.vue